import React from 'react'

import { AspectContainer } from 'components/layout'
import { Icon, Image } from 'components/dataDisplay'


export const bgColors = {
  'white': 'fff',
  'light-beige': 'f7efe9',
  'gray-10': 'fafafa',
  'gray-20': 'f0f0f0',
  'gray-30': 'dadada',
}

export type BgColor = keyof typeof bgColors | string

export type ProductImageProps = {
  className?: string
  bgColor?: BgColor
  src: string
  alt?: string
  fit?: 'cover' | 'contain'
  lazy?: boolean
}

const ProductImage: React.FunctionComponent<ProductImageProps> = (props) => {
  const { className, src, alt, bgColor = 'white', fit = 'contain', lazy } = props

  if (!src) {
    return (
      <AspectContainer className={className} fit={fit}>
        <Icon name="other/product" />
      </AspectContainer>
    )
  }

  // check for bgColor to have an option to request transparent png image by passing 'bgColor={null}'
  const isRebrandImage = Boolean(bgColor && /^[^\/].*\.png/.test(src))

  const finalSrc = isRebrandImage ? src.replace('.png', '.jpg') : src
  const imageBgColor = isRebrandImage ? bgColors[bgColor] || bgColor : null

  return (
    <AspectContainer className={className} fit={fit}>
      <Image
        src={finalSrc}
        alt={alt}
        bgColor={imageBgColor}
        lazy={lazy}
      />
    </AspectContainer>
  )
}


export default React.memo(ProductImage)
